import { reverseGeocode } from "./hereGeocoding";

const getHumanAddress = async (lat, lng, apiKey, language = "en") => {
  if (typeof lat !== "number" || typeof lng !== "number") {
    console.warn("Invalid lat or lng:", lat, lng);
    return "Invalid coordinates";
  }
  if (!apiKey) {
    console.warn("Missing HERE API key");
    return "Unknown address";
  }
  try {
    const result = await reverseGeocode(lat, lng, apiKey, { language });
    if (result?.address) return result.address;
    return "Unknown address";
  } catch (error) {
    console.error("Error during reverse geocoding:", error);
    return "Error retrieving address";
  }
};

export default getHumanAddress;
